export class FilterModel {
}
